import { render } from "./CollectDeviceData.vue?vue&type=template&id=3e274f95&scoped=true&ts=true"
import script from "./CollectDeviceData.vue?vue&type=script&lang=ts"
export * from "./CollectDeviceData.vue?vue&type=script&lang=ts"

import "./CollectDeviceData.vue?vue&type=style&index=0&id=3e274f95&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e274f95"]])

export default __exports__